import React, { useState } from 'react';
import './Login.css';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from './firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';

function Signup() {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate(); // Initialize useNavigate

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      console.log('Account created successfully');
      navigate('/Mainproject'); // Redirect to the main project page after successful sign up
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className='login-page'>
      <div className='Login-container'>
        <form className='signup-form' onSubmit={handleSubmit}>
          <h2>Sign up</h2>
          <label htmlFor='email'>
            Email:
            <input type="text" onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label htmlFor='password'>
            Password:
            <input type="password" onChange={(e) => setPassword(e.target.value)} />
          </label>
          <button type="submit">Sign up</button>
          <p>Already have an account? <Link to="/login">Login</Link></p>
        </form> 
      </div>
    </div>
  );
}

export default Signup;
